export const KYC_MANUAL_NAMES = {
  DOC_ID_FORM: "DOC_ID_FORM",
  PERSONAL_INFO_FORM: "PERSONAL_INFO_FORM",
  BIRTH_INFO_FORM: "BIRTH_INFO_FORM",
  DOC_ID_PICTURE: "DOC_ID_PICTURE",
  ADDITIONAL_DATA_GROUP: "ADDITIONAL_DATA_GROUP",
};
